"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsReferencedByFieldQueryGrid = void 0;
const tslib_1 = require("tslib");
const shared_urls_1 = require("@tableau/shared-urls");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    const field = resultData && resultData.fields && resultData.fields[0];
    switch (field.__typename) {
        case 'BinField':
        case 'CalculatedField':
        case 'CombinedField':
        case 'CombinedSetField':
        case 'GroupField':
        case 'HierarchyField':
        case 'SetField':
            return field && field.fieldsConnection;
        default:
            return null;
    }
}
// TODO: jschneidereit verify
function mapResultNode(node) {
    var _a, _b;
    const { id, name } = node;
    const datasource = node.datasource;
    const rest = {
        id,
        name,
        datasourceName: null,
        embeddedDatasourceNodeId: null,
        publishedDatasourceVizportalUrlId: null,
        workbookVizportalUrlId: null,
    };
    if (!datasource) {
        return rest;
    }
    const datasourceName = datasource.name;
    switch (datasource.__typename) {
        case 'EmbeddedDatasource':
            return Object.assign(Object.assign({}, rest), { datasourceName, embeddedDatasourceNodeId: datasource.id, workbookVizportalUrlId: (_b = (_a = datasource.workbook) === null || _a === void 0 ? void 0 : _a.vizportalUrlId) !== null && _b !== void 0 ? _b : null });
        case 'PublishedDatasource':
            return Object.assign(Object.assign({}, rest), { datasourceName, publishedDatasourceVizportalUrlId: datasource.vizportalUrlId });
        default:
            (0, vizportalclient_common_components_1.assertUnreachable)(datasource);
            return rest;
    }
    // const rest: GridRowData = {
    //   id,
    //   name,
    //   datasourceName: datasource?.name ?? null,
    //   embeddedDatasourceNodeId: datasource?.__typename === 'EmbeddedDatasource' ? datasource.id : null
    // }
    // const publishedDatasource = datasource && datasource.__typename === 'PublishedDatasource' ? datasource : null;
    // const embeddedDatasource = datasource && datasource.__typename === 'EmbeddedDatasource' ? datasource : null;
    // const workbook = embeddedDatasource ? embeddedDatasource.workbook : null;
    // return {
    //   id: node.id,
    //   name: node.name,
    //   publishedDatasourceVizportalUrlId: publishedDatasource ? publishedDatasource.vizportalUrlId : null,
    //   embeddedDatasourceNodeId: embeddedDatasource ? embeddedDatasource.id : null,
    //   datasourceName: datasource ? datasource.name : null,
    //   workbookVizportalUrlId: datasource && 'workbook' in datasource ? datasource.workbook?.vizportalUrlId : null,
    // };
}
function urlForLink(urls, rowData) {
    if (rowData.workbookVizportalUrlId && rowData.embeddedDatasourceNodeId) {
        return urls.workbookLineageFieldPath(rowData.workbookVizportalUrlId, rowData.id)
            + filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId);
    }
    else if (rowData.publishedDatasourceVizportalUrlId) {
        return urls.datasourceLineageFieldPath(rowData.publishedDatasourceVizportalUrlId, rowData.id);
    }
    return null;
}
function urlForAnchorLink(urls, rowData) {
    if (rowData.workbookVizportalUrlId && rowData.embeddedDatasourceNodeId) {
        return urls.workbookLineageFieldUrl(rowData.workbookVizportalUrlId, rowData.id)
            + filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId);
    }
    else if (rowData.publishedDatasourceVizportalUrlId) {
        return urls.datasourceLineageFieldUrl(rowData.publishedDatasourceVizportalUrlId, rowData.id);
    }
    return null;
}
function filterToEmbeddedDatasource(datasourceId) {
    return `?${shared_urls_1.CatalogUrlParamKeys.embeddedDataSource}=` + datasourceId;
}
function nameForLink(rowData) {
    if (rowData.name === null || rowData.datasourceName === null) {
        return null;
    }
    return catalog_messages_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.datasourceName });
}
function FieldsReferencedByFieldQueryGrid(props) {
    const emptyGridMessage = catalog_messages_1.Messages.EmptyFieldsReferencedByFieldGridMessage();
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.FieldsReferencedByFieldDocument, partialQueryVariables: { fieldId: props.fieldId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: props.useAnchor ? urlForAnchorLink : urlForLink, name: nameForLink, targetBlank: props.targetBlank, useAnchor: props.useAnchor }))));
}
exports.FieldsReferencedByFieldQueryGrid = FieldsReferencedByFieldQueryGrid;
//# sourceMappingURL=FieldsReferencedByFieldQueryGrid.js.map